<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">渠道名称</span>
				<el-input
					class="input-box"
					clearable
					v-model="searchBox.channelName"
				></el-input>
			</div>
			<div class="search-item">
				<span class="label">合作状态</span>
				<el-select
					v-model="searchBox.channelStatus"
					clearable
					placeholder="请选择"
				>
					<el-option
						v-for="item in channelStatusList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					>
					</el-option>
				</el-select>
			</div>
			<el-button
				v-auth="'sa_channel_page'"
				type="primary"
				class="search-btn"
				@click="search"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
			<el-button
				v-auth="'sa_channel_save'"
				type="warning"
				class="search-btn"
				@click="toAdd(null, 1)"
				>新增</el-button>
		</div>
		<div class="table-x" ref="tableBox">
			<el-table
				v-loading="loading"
				:data="tableData"
				:height="tableHeight"
				border
				class="mb10"
			>
				<el-table-column
					type="index"
					align="center"
					label="序号"
					width="80"
				>
				</el-table-column>
				<el-table-column
					prop="channelName"
					align="center"
					label="渠道名称"
					min-width="150"
				>
				</el-table-column>
				<el-table-column
					prop="startDate"
					align="center"
					label="合作起期"
					min-width="120"
				>
				</el-table-column>
				<el-table-column
					prop="endDate"
					align="center"
					label="合作止期"
					min-width="120"
				>
				</el-table-column>
				<el-table-column
					prop="createName"
					align="center"
					label="创建人"
					min-width="100"
				>
				</el-table-column>
				<el-table-column
					prop="createTime"
					align="center"
					label="创建时间"
					min-width="160"
				>
				</el-table-column>
				<el-table-column align="center" label="合作状态" width="100">
					<template slot-scope="scope">
						{{ scope.row.channelStatus === 1 ? "合作中" : "已终止" }}
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="150" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button
								v-auth="'sa_channel_save'"
								type="text"
								size="small"
								class="table-btn"
								@click="toAdd(scope.row, 2)"
								>详情</el-button
							>
							<el-button
								v-auth="'sa_channel_save'"
								type="text"
								size="small"
								class="table-btn"
								@click="toAdd(scope.row, 3)"
								>修改</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 分页部分 -->
		<div class="pagenation-x">
			<div class="pagination mb20">
				<el-pagination
					@current-change="handleCurrentChange"
					:current-page.sync="searchBox.pageNum"
					@size-change="getData"
					:page-sizes="[10, 50, 100]"
					:page-size.sync="searchBox.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					background
				>
				</el-pagination>
			</div>
		</div>
		<!-- 添加、修改弹层 -->
		<el-dialog
			append-to-body
			:dialogTitle="dialogTitle"
			:visible.sync="dialogVisible"
			class="edit-dialog"
			left
			:close-on-click-modal="false"
		>
			<el-form
				ref="form"
				:model="formData"
				:rules="formRules"
				label-width="120px"
			>
				<el-form-item label="渠道名称" prop="channelName">
					<el-input
						v-model.trim="formData.channelName"
						maxlength="50"
						clearable
						:disabled="formType === 2"
					></el-input>
				</el-form-item>
				<el-form-item label="合作起期" prop="startDate">
					<el-date-picker
						v-model="formData.startDate"
						type="date"
						placeholder="选择日期"
						:disabled="formType === 2"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="合作止期" prop="endDate">
					<el-date-picker
						v-model="formData.endDate"
						type="date"
						placeholder="选择日期"
						:disabled="formType === 2"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="合作状态" prop="channelStatus">
					<el-select
						v-model="formData.channelStatus"
						placeholder="请选择"
						:disabled="formType === 2"
					>
						<el-option label="合作中" :value="1"></el-option>
						<el-option label="已终止" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系人" prop="contactPerson">
					<el-input
						v-model.trim="formData.contactPerson"
						maxlength="20"
						clearable
						:disabled="formType === 2"
					></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="contactPhone">
					<el-input
						v-model.trim="formData.contactPhone"
						maxlength="20"
						clearable
						:disabled="formType === 2"
					></el-input>
				</el-form-item>
				<el-form-item label="联系邮箱" prop="contactEmail">
					<el-input
						v-model.trim="formData.contactEmail"
						maxlength="50"
						clearable
						:disabled="formType === 2"
					></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input
						type="textarea"
						v-model.trim="formData.remark"
						:rows="3"
						maxlength="500"
						clearable
						:disabled="formType === 2"
					></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button
					v-if="formType !== 2"
					type="primary"
					:loading="submitLoading"
					@click="submit"
					>保存</el-button
				>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
export default {
	data() {
		return {
			tableData: [],
			tableHeight: 400,
			loading: false,
			total: 0,
			dialogVisible: false,
			dialogLoading: false,
			submitLoading: false,
			formType: 1, // 1-新增 2-查看 3-修改
			resizeFlag: null,
			isEdit: false,
			channelId: "",
			channelStatusList: [
				{ value: 1, label: "合作中" },
				{ value: 0, label: "已终止" },
			],
			searchBox: {
				channelName: "",
				channelStatus: "",
				pageNum: 1,
				pageSize: 10,
			},
			formData: {
				channelName: "",
				startDate: "",
				endDate: "",
				channelStatus: 1,
				contactPerson: "",
				contactPhone: "",
				contactEmail: "",
				remark: "",
			},
			formRules: {
				channelName: [
					{
						required: true,
						message: "请输入渠道名称",
						trigger: "blur",
					},
				],
				channelStatus: [
					{
						required: true,
						message: "请选择合作状态",
						trigger: "change",
					},
				],
			},
		};
	},
	computed: {
		dialogTitle() {
			return this.formType === 1
				? "新增渠道"
				: this.formType === 2
				? "渠道详情"
				: "修改渠道";
		},
	},
	created() {
		this.$root.breadList = [
			{ name: "系统管理", link: "" },
			{ name: "渠道配置", link: "" },
		];
	},
	mounted() {
		this.$nextTick(() => {
			this.listenWindow();
			this.getData();
		});
	},
	methods: {
		//窗口改变，重新取得高度
		listenWindow() {
			this.tableHeight = this.$refs.tableBox.offsetHeight;
			window.addEventListener("resize", () => {
				clearTimeout(this.resizeFlag);
				this.resizeFlag = setTimeout(() => {
					try {
						this.tableHeight = this.$refs.tableBox.offsetHeight;
					} catch (error) {}
				}, 300);
			});
		},
		// 搜索
		search() {
			this.searchBox.pageNum = 1;
			this.getData();
		},
		// 重置
		reset() {
			this.searchBox = {
				channelName: "",
				channelStatus: "",
				pageNum: 1,
				pageSize: 10,
			};
			this.getData();
		},
		// 获取列表数据
		getData() {
			this.loading = true;
			// TODO: 调用接口获取数据，这里先用模拟数据
			// this.axios.get(this.getApiUrl("channelPage"), { params: this.searchBox }).then((res) => {})
			
			// 模拟数据
			setTimeout(() => {
				this.tableData = [];
				this.total = 0;
				this.loading = false;
			}, 500);
		},
		// 分页
		handleCurrentChange(val) {
			this.searchBox.pageNum = val;
			this.getData();
		},
		// 新增/详情/修改
		toAdd(row, type) {
			this.formType = type;
			this.isEdit = type === 3;
			this.$nextTick(() => {
				this.$refs.form && this.$refs.form.resetFields();
			});
			if (row) {
				this.channelId = row.channelId;
				this.getDetail(row.channelId);
			} else {
				this.channelId = "";
				this.formData = {
					channelName: "",
					startDate: "",
					endDate: "",
					channelStatus: 1,
					contactPerson: "",
					contactPhone: "",
					contactEmail: "",
					remark: "",
				};
			}
			this.dialogVisible = true;
		},
		// 获取详情
		getDetail(channelId) {
			// TODO: 调用接口获取详情
			// this.axios.get(this.getApiUrl("channelView"), { params: { channelId } }).then((res) => {})
		},
		// 提交
		submit() {
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return false;
				}
				this.submitLoading = true;
				// TODO: 调用接口保存
				// const api = this.isEdit ? "channelUpdate" : "channelSave";
				// this.axios.post(this.getApiUrl(api), this.formData).then((res) => {})
				
				setTimeout(() => {
					this.submitLoading = false;
					this.$message.success("操作成功");
					this.dialogVisible = false;
					this.getData();
				}, 500);
			});
		},
	},
};
</script>

<style scoped>
.search-x {
	display: flex;
	flex-wrap: wrap;
	padding: 20px 20px 0;
}
.search-item {
	margin-right: 20px;
	margin-bottom: 15px;
}
.label {
	display: inline-block;
	margin-right: 5px;
	margin-bottom: 5px;
	color: #606266;
	font-size: 14px;
}
.input-box {
	width: 180px;
}
.table-x {
	flex: 1;
	padding: 0 20px;
	overflow: hidden;
}
.pagenation-x {
	padding: 0 20px;
}
.table-btn {
	padding: 0 5px;
}
.dialog-footer {
	text-align: center;
}
</style>